import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { talkingPointDeleteActionText } from 'Const/brief-live/view';
import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';

import deleteTalkingPoint from 'Api/brief-live/deleteTalkingPoint';

const useDeleteTalkingPoint = () => {
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();
  const { onResetModal } = useModal();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteTalkingPoint({ id });
    },
    onSuccess: () => {
      onResetToast();
      onResetModal();
      queryClient.invalidateQueries({ queryKey: ['talking-point-list'] });

      onOpenToast({
        status: 'success',
        description: talkingPointDeleteActionText?.successDescription,
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : talkingPointDeleteActionText?.errorDescription;
      onResetToast();

      onOpenToast({
        status: 'error',
        title: talkingPointDeleteActionText?.errorTitle,
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useDeleteTalkingPoint;
